import { Component, OnInit, QueryList, ViewChildren, OnDestroy, ViewChild } from '@angular/core';
import { AccountCriteria, AccountCriteriaGroup } from './_models/account-criteria';
import { SortEvent, SortableDirective } from 'src/app/_directives/sortable.directive';
import { BehaviorSubject } from 'rxjs';
import { HeaderData } from 'src/app/_models/header-data';
import { AccountService } from '../_services/account.service';
import { Router } from '@angular/router';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/_services/common.service';
import { StatusCode, Modules } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss']
})
export class AccountListComponent implements OnInit, OnDestroy {

  private criteria: AccountCriteria;
  private hasAccounts: boolean = true;
  private _total$ = new BehaviorSubject<number>(0);
  private loading: boolean = false;
  private selectedFilterType: any = [];
  
  resultsNotFound = RESULTS_NOT_FOUND;

  private selectedType: any;
  private defaultFilterObj : any = [];
  private filterObj: any = [
    {filterIndex: 1, displayName : 'Agency Bill', value: 'Agency', group: AccountCriteriaGroup.group, isChecked: false},
    {filterIndex: 2, displayName : 'Direct Bill: Installment Plan', value: 'Installment', group: AccountCriteriaGroup.group, isChecked: false},
    {filterIndex: 3, displayName : 'Direct Bill: Monthly Reporter', value: 'MR', group: AccountCriteriaGroup.group, isChecked: false}
  ];
  private isAllUnchecked: boolean = true;

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  
  private accounts;
  hasAccess:boolean = false;
  //private killServicesOnDestroy = [];

  @ViewChildren(SortableDirective) headers: QueryList<SortableDirective>;
  @ViewChild('myDrop', { static: true }) myDrop: NgbDropdown;
  
  constructor(private router: Router, private accountService: AccountService, private commonService: CommonService) { 
    if(!this.commonService.checkPermission(Modules.AccountList)){
      console.log("No Permissions");
    }
  }

  ngOnInit() {
    this.criteria = new AccountCriteria();
    this.selectedType = this.defaultFilterObj;
    this.criteria.filterBy = this.setDefaultCriteria();
    this.criteria.sortBy = "AccountName";
    this.criteria.sortOrder = "asc";

    this.fetchAccounts();

    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
  }

  setHeaderData(){
    this.headerData.pageTitle = "Accounts";
    this.accountService.header = this.headerData;  
  }

  setDefaultCriteria() {
    this.defaultFilterObj = [];
    this.filterObj.forEach(obj => {
      let _filterObj = {
        "FilterColumnName": obj.group,
        "FilterValue": obj.value
      };
      this.defaultFilterObj.push(_filterObj);
    });

    return this.defaultFilterObj;
  }

  fetchAccounts(){
    this.loading = true;
    this.hasAccounts = true;
    console.log('this.criteria :: ', this.criteria);
    let accountSubscription = this.accountService.fetchAccounts(this.criteria).subscribe((accounts:any) => {
      this.loading = false;
      this._total$.next(accounts.total);
      this.accounts = accounts.account;
      this.hasAccounts = this.accounts && this.accounts.length > 0;
      this.hasAccess = true;

      if (this.myDrop.isOpen()){
        this.myDrop.close();
      }
    },error=>{
      this.loading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.accountService.runningServices.push(accountSubscription);
  }

  get total$() { return this._total$.asObservable(); }

  /* ***Filter Code*** */
  setFilterValue(_event, _filter) {
    this.ngOnDestroy();

    let el = this.selectedFilterType.find(itm => itm.FilterValue === _filter.value);
    
    if(_event.target.checked) {
      if(!el) {
        let _criteria = {
          "FilterColumnName": _filter.group,
          "FilterValue": _filter.value
        };
        this.selectedFilterType.push(_criteria);
      }
    } else {      
      if(el)
        this.selectedFilterType.splice(this.selectedFilterType.indexOf(el),1);
    }
    
    this.onFilter(this.selectedFilterType);
  }

  onFilter(_filter){
    this.isAllUnchecked = this.isAllCheckboxesUnchecked();
    console.log('_filter :: ', _filter);
    this.criteria.filterBy = this.isAllUnchecked ? this.defaultFilterObj : _filter;
    this.criteria.sortBy = "AccountName";
    this.criteria.sortOrder = "asc";
    this.criteria.pageNo = 1;

    this.fetchAccounts();
    
  }

  resetFilters(event) {
    event.stopPropagation();
    this.filterObj.forEach(item => {
      item.isChecked = false;
    });
    this.selectedFilterType = [];
    this.onFilter(this.selectedFilterType);
  }

  isAllCheckboxesUnchecked() {
    let _isAllUnchecked: boolean = false;
    _isAllUnchecked = this.filterObj.every(function(item:any) {
      return item.isChecked == false;
    });
    console.log("_isAllUnchecked :: ", _isAllUnchecked);

    return _isAllUnchecked;
  }
  /* Filter Code */
  
  /* ***Sorting Code*** */
  onSort({column, direction}: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction !== '') {
      this.criteria.sortOrder = direction;
      this.criteria.sortBy = column;
      this.criteria.pageNo = 1;
      console.log("Call WebAPI to sort " + column + " column in " + direction + " order");
      this.fetchAccounts();
    }
  }
  /* Sorting Code */
  
  openAccountDetails(account){
    if(!account["accountEndorsementsTab"]){
      account.accountEndorsementsTab = null;
    }
    this.accountService.storeAccountData(account);
    this.router.navigateByUrl("accounts/"+account.accountNumber + "/policies");
  }

  openDirectBill(account){
    if(!account["accountEndorsementsTab"]){
      account.accountEndorsementsTab = null;
    }
    this.accountService.storeAccountData(account);
    this.router.navigateByUrl("accounts/"+account.accountNumber + "/directbill");
  }

  getBillType(billType, account){
    return (billType.toLowerCase() == "direct")?"<a class='normal-text-size' href='#' onclick='return false;' (click)='openDirectBill(account);'>"+billType+"</a>":billType;
  }
    
  ngOnDestroy() {
    this.accountService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}